import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { extractErrorMessage, useStore } from "../../../helpers";
import { TARS_ES_SAMPLE_DOC_PATH } from "../tars-constants";

/** True when Elasticsearch has no such index (expected for new / unstaged data). */
export function isEsIndexNotFoundError(error: unknown): boolean {
  const msg = (error instanceof Error ? error.message : String(error)).toLowerCase();
  return (
    msg.includes("404") ||
    msg.includes("index_not_found") ||
    msg.includes("no such index") ||
    msg.includes("notfounderror")
  );
}

export interface EsSampleDocPayload {
  es_index: string;
}

export function extractProjectQuestionKeysFromSource(
  source: Record<string, unknown>
): string[] {
  return Object.keys(source).filter(
    (k) =>
      k.startsWith("qr_") || k.startsWith("profile_") || k.startsWith("piv_")
  );
}

export const useEsSampleDoc = () => {
  const rootStore = useStore();

  return useMutation({
    mutationFn: async (payload: EsSampleDocPayload) => {
      const res = await rootStore.apiRequestHandler(
        TARS_ES_SAMPLE_DOC_PATH,
        payload,
        "Failed to load sample document"
      );
      return res.data ?? res;
    },
    onError: (error: unknown) => {
      if (isEsIndexNotFoundError(error)) return;
      toast.error(extractErrorMessage(error, "Failed to load sample document"));
    },
  });
};
